import { call, put } from "redux-saga/effects";
import {
  deleteStore,
  editStore,
  getStores,
} from "../../app/components/Dashboard/helper/dashboardHelper";
import { addStore } from "../../app/components/Subscription/helper/subscriptionHelper";
import {
  addStoreSuccessAction,
  deleteStoreSuccessAction,
  editStoreSuccessAction,
  getStoresSuccessAction,
} from "./actions";

export function* addStoreSaga(action) {
  try {
    const response = yield call(addStore, action.store);
    yield put(addStoreSuccessAction, response.data);
  } catch (err) {
  }
}

export function* getStoresSaga(action) {
  try {
    const response = yield call(getStores, action.userId);
    yield put(getStoresSuccessAction(response.data));
  } catch (err) {
  }
}

export function* editStoreSaga(action) {
  try {
    const response = yield call(editStore, action.store);
    yield put(editStoreSuccessAction(response.data));
  } catch (err) {
  }
}

export function* deleteStoreSaga(action) {
  try {
    yield call(deleteStore, action.store);
    yield put(deleteStoreSuccessAction(action.store));
  } catch (err) {
  }
}
